// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Pie de página institucional sin fondo
 * Muestra el distintivo centrado "Powered by Interaktia" con tracking UTM
 * y el enlace permanente a la Política de Cookies.
 */
export default function Footer() {
  return (
    <footer className="footer-interaktia py-4 mt-auto text-center">
      <div className="container d-flex flex-column align-items-center gap-2">
        <a
          href="https://interaktia.com/?utm_source=xolofest&utm_medium=referral&utm_campaign=xolofest2026"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-interaktia-link"
        >
          Powered by Interaktia
        </a>
        <div className="footer-legal-links">
          <Link to="/politica-cookies" className="footer-legal-link text-decoration-none">
            Política de Cookies
          </Link>
        </div>
      </div>
    </footer>
  );
}
